import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";
import { format } from "date-fns";
import { renderFieldInput } from "../../components/fieldsInputs/renderFieldInput";
import { ordersOptions } from "./ordersOptions";
import { findField } from "../../utils/findField";
import { getFieldExtraOption } from "../../utils/getFieldExtraOption";
import { UseFormReturn, useWatch } from "react-hook-form";
import { OrderPurchaseNotes } from "./OrderPurchaseNotes";

type OrderHeaderFieldsProps = {
	entityForm: UseFormReturn;
};

export const OrderHeaderFields = ({ entityForm }: OrderHeaderFieldsProps) => {
	const recordContext = useContext(RecordContext);
	const selectedTreatment = useWatch({ control: entityForm.control, name: "treatment" });

	if (!recordContext) return null;

	const dateField = findField(recordContext.formatedFields, "order_date");
	const treatmentField = findField(recordContext.formatedFields, "treatment");
	const clinicField = findField(recordContext.formatedFields, "clinic");

	const payment_status = findField(recordContext.formatedFields, "payment_status");
	const payment_date = findField(recordContext.formatedFields, "payment_date");

	return (
		<Box>
			<Grid container alignItems="center" flexGrow={1} justifyContent="flex-start" spacing={3} mt={5}>
				<Grid xs={12} md={6} lg={4}>
					{treatmentField &&
						renderFieldInput(
							treatmentField,
							{ treatment: recordContext.item?.treatment || "" },
							"group",
							entityForm,
							getFieldExtraOption(ordersOptions?.groupsOptions.fieldsWithExtraOptions, treatmentField)
						)}
				</Grid>
				<Grid xs={12} md={6} lg={4}>
					{dateField &&
						renderFieldInput(
							dateField,
							{ order_date: recordContext.item?.order_date || format(new Date(), "yyyy-MM-dd HH:mm") },
							"group",
							entityForm
						)}
				</Grid>
				<Grid xs={12} md={6} lg={4}>
					{clinicField &&
						renderFieldInput(
							clinicField,
							{ clinic: recordContext.item?.clinic || "" },
							"group",
							entityForm,
							{ enabled: true, filter: { id: { _neq: 2 } } }
						)}
				</Grid>
			</Grid>
			<Grid container alignItems="center" flexGrow={1} justifyContent="flex-start" spacing={3} mt={5}>
				<Grid xs={12} md={6} lg={4}>
					{payment_status &&
						renderFieldInput(
							payment_status,
							{ payment_status: recordContext.item?.payment_status || "" },
							"group",
							entityForm
						)}
				</Grid>
				<Grid xs={12} md={6} lg={2}>
					{payment_date &&
						entityForm.watch("payment_status") === "paid" &&
						renderFieldInput(
							payment_date,
							{
								payment_date: recordContext.item?.payment_date || format(new Date(), "yyyy-MM-dd HH:mm")
							},
							"group",
							entityForm
						)}
				</Grid>
				<Grid xs={12} md={6} lg={4} sx={{ marginLeft: "auto" }}>
					<OrderPurchaseNotes
						treatmentId={selectedTreatment?.id || selectedTreatment}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};
